import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../../../index.css";
import './leaveorgin.css';
import Swal from 'sweetalert2';
import axios from 'axios';
import { EditHolidayCalendars, HEADERS, getOrgId } from '../../api';

export default function EditHolidayCalendar() {
  const urlParams = new URLSearchParams(window.location.search);
  const navigate = useNavigate();

  // State to store query parameters
  //const [holidayCalendarId, setHolidayCalendarId] = useState('');
  const [calendarName, setCalendarName] = useState('');

  const Holiday_idssssssssss = urlParams.get('holiday_calendar_id') || '';
  const holidays_namesssssssssss = urlParams.get('calendar_name') || '';

  const check = Holiday_idssssssssss
  // $&

  // Function to handle the update
  const handleUpdate = async () => {
    const OrgID = getOrgId();
    const holidayRequestId = urlParams.get('holiday_calendar_id') || '';

    const updatedData = {
      org_id: OrgID,
      calendar_id: holidayRequestId,
      calendar_name: calendarName,
    };

    // $&



    // Call your API here using Axios
    const response = await axios.post(EditHolidayCalendars, updatedData, { headers: HEADERS })
      .then(response => {
        // $&

        // Handle success
        Swal.fire('Update successful!', 'The holiday calendar has been updated.', 'success');

        // Navigate back to the main page (adjust the path as needed)
        navigate('/leave-page/holiday-calander');
      })
      .catch(error => {
        // Handle error
        Swal.fire('Error', 'Failed to update the holiday calendar.', 'error');
      });
  };

  return (
    <div className="box">
      <div className="row">
        <div className="col-lg-6">
          <h5>Edit Holiday Calendar</h5>
          <div className="card mt-3" id='cards'>
            <div className="d-flex holiday">
              <div className="form-group p-3 col-md-9">
                <label>Holiday Type</label>
                <input
                  type="text"
                  placeholder="Bhutan"
                  value={calendarName}
                  onChange={(e) => setCalendarName(e.target.value)}
                  required
                />
              </div>
              <div className="form-group input-check mt-3">
                <input type="checkbox" id="check" className="" />
                <label className="" htmlFor="check">
                  Disable
                </label>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end mt-2 cancel-update">
            <button
              type="button"
              className="button-outline"
              onClick={() => navigate('/leave-page/holiday-calander')}
            >
              Cancel
            </button>
            <button className="button-outline" onClick={handleUpdate}>
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
